/** Privacy-minimal integration point for conversion measurement. No network/storage or wallet identifiers. */
export type JourneyEvent = 'race_viewed' | 'trade_opened' | 'wallet_connect_requested' | 'quote_ready' | 'trade_submitted' | 'trade_result' | 'result_viewed' | 'account_viewed';
export function journey(event: JourneyEvent, context: { phase?: string; side?: 'buy' | 'sell'; stage?: string; mode?: string } = {}) {
  window.dispatchEvent(new CustomEvent('runner:journey', { detail: { event, ...context } }));
}
